// pages/CV.jsx
import React from 'react';

const CV = () => {
    return (
        <div className="container">
            <div className="section-header" style={{ position: 'relative', textAlign: 'center', marginBottom: '3rem' }}>
                <h2 className="section-title">Professional Journey</h2>
                <p style={{ maxWidth: '700px', margin: '0 auto' }}>
                    A chronicle of exhibitions, achievements, and artistic milestones throughout Samir Dutta's career as a pioneering artist fusing traditional folk art with contemporary expressions.
                </p>
            </div>

            <div className="cv-container" style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 5px 30px rgba(0, 0, 0, 0.1)',
                padding: '3rem',
                maxWidth: '900px',
                margin: '0 auto',
                position: 'relative',
                overflow: 'hidden'
            }}>
                <div style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '5px',
                    background: 'linear-gradient(to right, var(--primary-color), var(--secondary-color), var(--accent-color))'
                }}></div>

                <div className="cv-header">
                    <h2 style={{
                        fontSize: '2.5rem',
                        marginBottom: '0.5rem',
                        color: 'var(--primary-color)',
                        position: 'relative',
                        display: 'inline-block'
                    }}>
                        Samir Dutta
                        <span style={{
                            display: 'block',
                            fontSize: '1rem',
                            fontWeight: 'normal',
                            fontFamily: 'var(--font-secondary)',
                            color: 'var(--text-color)',
                            marginTop: '0.5rem'
                        }}>
                            সমীর দত্ত
                        </span>
                    </h2>
                    <p style={{ fontSize: '1.2rem', color: 'var(--accent-color)' }}>
                        Folk Modernist Artist | Cultural Storyteller | Art Educator
                    </p>
                    <p style={{ fontSize: '1rem', marginTop: '0.5rem' }}>
                        <i className="fas fa-map-marker-alt" style={{ marginRight: '0.5rem', color: 'var(--primary-color)' }}></i>
                        AA-44, P.O.-Prafulla kanan, Kester, West, Kolkata-700101, West Bengal
                    </p>
                    <p style={{ fontSize: '1rem', marginTop: '0.5rem' }}>
                        <i className="fas fa-phone" style={{ marginRight: '0.5rem', color: 'var(--primary-color)' }}></i>
                        +91 9339858128 / 8981201315
                    </p>
                    <p style={{ fontSize: '1rem', marginTop: '0.5rem' }}>
                        <i className="fas fa-envelope" style={{ marginRight: '0.5rem', color: 'var(--primary-color)' }}></i>
                        samirdutta007@gmail.com
                    </p>
                </div>

                {/* Education Section */}
                <div className="cv-section">
                    <h3 style={{
                        fontSize: '1.8rem',
                        marginBottom: '1.5rem',
                        position: 'relative',
                        paddingLeft: '2rem',
                        color: 'var(--primary-color)'
                    }}>
                        <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: 'var(--secondary-color)'
                        }}></span>
                        Education
                    </h3>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                Master of Fine Arts (M.F.A)
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2003</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            Government College of Art & Craft, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                Bachelor of Fine Arts (B.F.A)
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2000</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            Government College of Art & Craft, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                Madhyamik
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>1995</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            Academic Qualification
                        </div>
                    </div>
                </div>

                {/* Specialization Section */}
                <div className="cv-section">
                    <h3 style={{
                        fontSize: '1.8rem',
                        marginBottom: '1.5rem',
                        position: 'relative',
                        paddingLeft: '2rem',
                        color: 'var(--primary-color)'
                    }}>
                        <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: 'var(--secondary-color)'
                        }}></span>
                        Specialization
                    </h3>

                    <div className="cv-item">
                        <p>Water Colour, Wash Painting, Tempera and Oil or Acrylic, etc.</p>
                    </div>
                </div>

                {/* Teaching Experience Section */}
                <div className="cv-section">
                    <h3 style={{
                        fontSize: '1.8rem',
                        marginBottom: '1.5rem',
                        position: 'relative',
                        paddingLeft: '2rem',
                        color: 'var(--primary-color)'
                    }}>
                        <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: 'var(--secondary-color)'
                        }}></span>
                        Teaching Experience
                    </h3>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                Senior Art Teacher
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2022-2024</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            Birla Academy Art and Culture, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                Art Teacher
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2010-2022</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            Nehru Children Museum, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                Art Teacher
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2016-2018</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            Impart Art Coaching, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                Art Teacher
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2014-2018</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            Art House, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                Art Teacher
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2004-2009</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            Abhinava High School, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                Art Director
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}></div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            Tollywood, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                Badminton Coach
                            </div>
                        </div>
                    </div>
                </div>

                {/* Solo Exhibitions Section */}
                <div className="cv-section" >
                    <div style={{
                        position: 'absolute',
                        left: '20px',
                        top: '0',
                        bottom: '0',
                        width: '1px',
                        background: 'linear-gradient(to bottom, transparent, var(--secondary-color), transparent)',
                        zIndex: 0
                    }}></div>

                    <h3 style={{
                        fontSize: '1.8rem',
                        marginBottom: '1.5rem',
                        position: 'relative',
                        paddingLeft: '2rem',
                        color: 'var(--primary-color)'
                    }}>
                        <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: 'var(--secondary-color)'
                        }}></span>
                        Solo Exhibitions
                    </h3>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                "MYTHOLOGY" (10th Solo Exhibition)
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2023</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            The Stadel Hotel, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                "FUTURE FOLK ART – III" (9th Solo Exhibition)
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2019</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            The Stadel Hotel, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                "Emerging History of Future Folk Art - II" (8th Solo Exhibition)
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2014</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            Academy of Fine Arts, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                "TRADITION" (7th Solo Exhibition)
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2013</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            The Stadel, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                "2WAY" (6th Solo Exhibition)
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2012</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            Lalit Kala Academi, Rabindra Bhavan, Delhi
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                "EMERGING HISTORY OF FUTURE FOLK ART" (5th Solo Exhibition)
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2011</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            Academy of Fine Arts, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                4th Solo Exhibition
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2011</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            The Stadel, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                3rd Solo Exhibition
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2010</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            Academy of Fine Arts, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                2nd Solo Exhibition
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2010</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            The Stadel, Kolkata
                        </div>
                    </div>

                    <div className="cv-item">
                        <div className="cv-item-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <div className="cv-item-title" style={{ fontWeight: '700', fontSize: '1.2rem' }}>
                                "A BAQUAT OF ART ON THE ADVENT OF THE PUJAS" (1st Solo Exhibition)
                            </div>
                            <div className="cv-item-period" style={{ color: 'var(--accent-color)', fontWeight: '500' }}>2009</div>
                        </div>
                        <div className="cv-item-subtitle" style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
                            The Stadel, Kolkata
                        </div>
                    </div>
                </div>

                {/* Awards Section */}
                <div className="cv-section">
                    <h3 style={{
                        fontSize: '1.8rem',
                        marginBottom: '1.5rem',
                        position: 'relative',
                        paddingLeft: '2rem',
                        color: 'var(--primary-color)'
                    }}>
                        <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: 'var(--secondary-color)'
                        }}></span>
                        Awards & Recognition
                    </h3>

                    <div className="cv-item">
                        <ul style={{ listStyleType: 'none', paddingLeft: '0' }}>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>LIVIN ART organised INTERNATIONAL ART EXHIBITION AT BANGLADESH</strong> - "BEST ACHIEVEMENT AWARD" (2023)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>FOCUS BANGLA ORGANISED INTERNATIONAL ART EXHIBITIONS AT BANGLADESH</strong> - "EXCELLENT AWARD" (2023)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>RONG TULI- TRIPURA</strong> - "Best Achievement Award" (2021)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>KALARATNAM</strong> - "Excellent Award" (2021)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>RETRO KOLKATA ART AWARD</strong> (2019)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>RABINDRA SAMMAN</strong> (2016)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>TIMES OF INDIA DURGA PUJA SAMMAN</strong> (2012)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>TWOER YUBA KALAYAN SAMMAN</strong> (2010, 2011)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>INDRA DUGAR SAMMAN</strong> (2007)
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Art Workshops Section */}
                <div className="cv-section">
                    <h3 style={{
                        fontSize: '1.8rem',
                        marginBottom: '1.5rem',
                        position: 'relative',
                        paddingLeft: '2rem',
                        color: 'var(--primary-color)'
                    }}>
                        <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: 'var(--secondary-color)'
                        }}></span>
                        Art Workshops
                    </h3>

                    <div className="cv-item">
                        <ul style={{ listStyleType: 'none', paddingLeft: '0' }}>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>BIKASIT BHARAT ARTIST WORKSHOP</strong> by Lalit Kala Academy & Modern Art Gallery, New Delhi Purana Qilla (2024)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>BRATA CHARI KALA BHAVAN ART WORKSHOP</strong>, Shukna Forest (2023)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>UDICHI ART SPACE</strong> as Guest Artist (2022)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>IWS DOOARS WATER SUMMIT</strong> as Guest Artist (2021)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>ITC CLUB FORTUNE</strong> organized INDO BANGLA DESH of KOLKATA (2011)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>ART MALL</strong>, New Delhi (2010)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>South City Mall</strong> "Shimul Music Circle" (2009)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>Unmesh Kala Kendra</strong> (2006)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>Children's Book Fair</strong>, Kolkata (2006)
                                </span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>
                                    <strong>Rotary Club of Dum Dum</strong> (2005)
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Collections Section */}
                <div className="cv-section">
                    <h3 style={{
                        fontSize: '1.8rem',
                        marginBottom: '1.5rem',
                        position: 'relative',
                        paddingLeft: '2rem',
                        color: 'var(--primary-color)'
                    }}>
                        <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: 'var(--secondary-color)'
                        }}></span>
                        Collections
                    </h3>

                    <div className="cv-item">
                        <p>Samir Dutta's artworks are in collections across the globe including Australia, Holland, Poland, Hong Kong, USA, Bahamas, Bangladesh, Mumbai, and Delhi.</p>
                    </div>
                </div>

                {/* Group Exhibitions Section - Highlights */}
                <div className="cv-section">
                    <h3 style={{
                        fontSize: '1.8rem',
                        marginBottom: '1.5rem',
                        position: 'relative',
                        paddingLeft: '2rem',
                        color: 'var(--primary-color)'
                    }}>
                        <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: 'var(--secondary-color)'
                        }}></span>
                        Selected Group Exhibitions
                    </h3>

                    <div className="cv-item">
                        <ul style={{ listStyleType: 'none', paddingLeft: '0', columns: '2', columnGap: '2rem' }}>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>World Art Organization Breast Cancer Support Exhibition, Taj Vivanta, Kolkata (2022)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>World Art Organization Breast Cancer Support Exhibition, Taj Bengal, Kolkata (2021)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>World Art Organization Breast Cancer Support Exhibition, Westin Hotel (Marriot), Kolkata (2021)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>Art & Artist National Level Mega Online Art Exhibition, The Last Flower (2020)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>Indian Royal Academy of Art and Culture International Art Exhibition on Covid-19 (2020)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>Nirantar Art 2nd Online International Exhibition (2020)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>2nd International Art Exhibition, Dushyant Art Gallery, Noida (2019)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>80th Annual Art Exhibition, Academy of Fine Arts Gallery, Kolkata (2016)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>"Nirvana" Group Exhibition, Visual Art Gallery, Delhi (2014)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>"Brush" Group Exhibition, Birla Academy & Culture, Kolkata (2013)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>"Tomorrow" Paintings and Sculptures Group Exhibition, Lalit Kala Academi, Delhi (2012)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>"Bel-Etage & Nirvana" Gallery Exhibition, Prinsengracht, Amsterdam, Holland (2008)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>Nehru Art Gallery, Washington D.C., Group Exhibition (2007)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>"Eye Within" Exhibition at Taj Bengal (2007)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>41st Annual Exhibition of Birla Academy & Culture (2007)</span>
                            </li>
                            <li style={{ marginBottom: '0.8rem', pageBreakInside: 'avoid', display: 'flex', alignItems: 'baseline' }}>
                                <span style={{ color: 'var(--secondary-color)', marginRight: '0.8rem' }}>○</span>
                                <span>71st Annual Exhibition of Academy of Fine Arts (2006)</span>
                            </li>
                        </ul>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                        <button className="btn" style={{ background: 'transparent', color: 'var(--primary-color)', border: '1px solid var(--primary-color)' }}>
                            View Complete Exhibition History
                        </button>
                    </div>
                </div>

                {/* Personal Information */}
                <div className="cv-section">
                    <h3 style={{
                        fontSize: '1.8rem',
                        marginBottom: '1.5rem',
                        position: 'relative',
                        paddingLeft: '2rem',
                        color: 'var(--primary-color)'
                    }}>
                        <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: 'var(--secondary-color)'
                        }}></span>
                        Personal Information
                    </h3>

                    <div className="cv-item">
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
                            <div>
                                <p><strong>Father's Name:</strong> Late Santosh Dutta</p>
                                <p><strong>Date of Birth:</strong> 4th March 1979</p>
                            </div>
                            <div>
                                <p><strong>Nationality:</strong> Indian</p>
                                <p><strong>Religion:</strong> Hindu</p>
                            </div>
                            <div>
                                <p><strong>Interests:</strong> Painting, Playing, Books & Music</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Download CV Button */}
                <div className="cv-download" style={{ textAlign: 'center', marginTop: '3rem' }}>
                    <a href="/documents/SamirDuttaCV.pdf" className="btn" download style={{
                        position: 'relative',
                        overflow: 'hidden',
                        backgroundColor: 'var(--accent-color)',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                    }}>
                        <i className="fas fa-download"></i> Download Complete CV
                    </a>
                </div>
            </div>
        </div>
    );
};

export default CV;
